// extracted by mini-css-extract-plugin
export default {"keyword_container":"KeywordContainer_keyword_container__mqgb1","noTenant":"KeywordContainer_noTenant__tsXKt"};